var _circle, _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 73,
    viewBox: "0 0 104 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 36.5,
    r: 36.266,
    fill: "url(#paint0_linear_506_3288)",
    stroke: "#81A9D7",
    strokeWidth: 0.467949
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5165 21.6545C77.5894 21.612 77.663 21.569 77.7374 21.5256C78.3617 21.1614 78.9668 20.8454 79.5552 20.5751C82.2679 25.2587 83.8207 30.698 83.8207 36.5C83.8207 54.074 69.5742 68.3205 52.0002 68.3205C34.4262 68.3205 20.1797 54.074 20.1797 36.5C20.1797 31.6712 21.2553 27.0936 23.18 22.9937C23.5112 23.1038 23.838 23.2148 24.1612 23.3245C28.3328 24.7409 31.9026 25.953 36.5579 22.4615C44.0451 16.8461 52.9361 17.3141 61.8271 21.5256C70.6091 25.6855 71.6497 25.0782 77.5165 21.6545Z",
    fill: "url(#paint1_linear_506_3288)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_506_3288)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 35.5,
    rx: 41.5,
    ry: 16.5,
    fill: "url(#paint2_linear_506_3288)",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.172 34.704V37.476H48.9V35.916H41.088V37.464H39.816V34.704H44.256C44.128 34.416 43.964 34.108 43.764 33.78L45.18 33.54C45.316 33.82 45.48 34.208 45.672 34.704H50.172ZM39.672 38.028H42.972C43.252 37.508 43.568 36.896 43.92 36.192L45.216 36.588L44.46 38.028H50.352V39.228H48.072C47.608 40.356 47.104 41.272 46.56 41.976C47.76 42.48 48.96 43.06 50.16 43.716L49.308 44.82C48.084 44.092 46.868 43.456 45.66 42.912C44.308 44.08 42.544 44.696 40.368 44.76L39.636 43.596C41.58 43.596 43.152 43.176 44.352 42.336C43.272 41.88 42.208 41.488 41.16 41.16C41.608 40.448 41.992 39.804 42.312 39.228H39.672V38.028ZM43.788 39.228C43.476 39.764 43.188 40.244 42.924 40.668C43.644 40.868 44.444 41.136 45.324 41.472C45.868 40.856 46.324 40.108 46.692 39.228H43.788ZM57.444 33.612C58.948 35.148 60.676 36.36 62.628 37.248L62.004 38.364C61.428 38.084 60.876 37.784 60.348 37.464V38.544H57.636V40.224H60.972V41.436H57.636V43.212H62.064V44.436H51.948V43.212H56.364V41.436H53.016V40.224H56.364V38.544H53.652V37.452C53.1 37.796 52.532 38.108 51.948 38.388L51.336 37.272C53.44 36.28 55.18 35.06 56.556 33.612H57.444ZM60.144 37.332C58.976 36.596 57.928 35.736 57 34.752C56.12 35.704 55.068 36.564 53.844 37.332H60.144Z",
    fill: "#112C56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_506_3288",
    x: 0.0179482,
    y: 8.51795,
    width: 103.964,
    height: 53.9641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24103,
    result: "effect1_foregroundBlur_506_3288"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_3288",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16547B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_3288",
    x1: 83.8207,
    y1: 36.868,
    x2: 20.1797,
    y2: 36.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#8ED9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EA4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_506_3288",
    x1: 93.5,
    y1: 35.5,
    x2: 10.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#69CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A7E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.8d6b9abc50c190d0fc6b22ca50fd1bc7.svg";
export { ForwardRef as ReactComponent };